import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

@Component({
	selector: 'app-administracao',
	templateUrl: './administracao.component.html',
	styleUrls: ['./administracao.component.scss', '../../assets/less/all.less']
})
export class AdministracaoComponent implements OnInit {

	constructor(
		private router: Router
	) { }

	ngOnInit() {
	}


	openClientes() {
		this.router.navigate(['/clientes'])
	}

	openUsuarios() {
		this.router.navigate(['/usuarios'])
	}

	openTipoDocumento() {
		this.router.navigate(['/tipos-documento'])
	}

}
